import { Asset } from 'common/models'

export const selectTempDataData = (state: any): Asset | null => {
  return state.getIn(['tempData', 'data'])
}

export const selectTempDataSaveAt = (state: any) => {
  return state.getIn(['tempData', 'savedAt'])
}
